import React from "react";
import { MinusIcon, PlusIcon, ShoppingCartIcon } from "lucide-react";
import { useCart } from "../contexts/CartContext";
import { SquareCatalogProduct } from "../types/SquareCatalog";
type QuantityControlProps = {
  product: SquareCatalogProduct;
  label: string;
};
export function QuantityControl({
  product,
  label
}: QuantityControlProps) {
  const {
    getQuantity,
    changeQuantity,
    openCart
  } = useCart();
  if (product.inventory <= 0) {
    return <p className="text-sm font-semibold text-[#ff5bad]" data-id="element-247" data-mp="mshnvqlml9c7">Sold Out</p>;
  }
  const quantity = getQuantity(product.variationId);
  const hasReachedInventory = quantity >= product.inventory;
  if (quantity === 0) {
    return <div data-square-variation-id={product.variationId} data-id="element-248" data-mp="rrawb4m22a5i">
        <p className="text-sm text-white/75" data-id="element-249" data-mp="rprfncwhlx37">{product.inventory} available</p>
        <button type="button" onClick={() => changeQuantity(product, 1)} className="mt-3 inline-flex items-center gap-2 rounded-full bg-[#ff3aa2] px-5 py-2.5 text-sm font-semibold text-white transition-colors duration-150 ease-out hover:bg-[#ff5bad] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#35dceb]" aria-label={`Add ${label} to cart`} data-id="element-250" data-mp="40ou3tyqfk3f">
          <ShoppingCartIcon size={16} aria-hidden="true" data-id="element-251" data-mp="26pdp4cknjk05" />
          Add to cart
        </button>
      </div>;
  }
  return <div data-square-variation-id={product.variationId} data-id="element-252" data-mp="1dyvjp4wgh6jk">
      <p className="text-sm text-white/75" data-id="element-253" data-mp="1e0gix7tptdnr">{product.inventory} available</p>
      <div className="mt-3 flex flex-wrap items-center gap-3" data-id="element-254" data-mp="1ixyruy7qfsvr">
        <button type="button" onClick={() => changeQuantity(product, -1)} className="inline-flex h-9 w-9 items-center justify-center border border-white/30 text-white transition-colors duration-150 ease-out hover:border-[#35dceb] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#35dceb]" aria-label={`Remove one ${label} from cart`} data-id="element-255" data-mp="1nw0aji18xq6p">
          <MinusIcon size={16} aria-hidden="true" data-id="element-256" data-mp="146z25ms6d1h1" />
        </button>
        <span className="min-w-6 text-center text-sm font-semibold" aria-live="polite" data-id="element-257" data-mp="za8m2zgde5vm">
          {quantity}
        </span>
        <button type="button" onClick={() => changeQuantity(product, 1)} disabled={hasReachedInventory} className="inline-flex h-9 w-9 items-center justify-center border border-[#35dceb] text-[#35dceb] transition-colors duration-150 ease-out hover:bg-[#35dceb] hover:text-[#10070f] disabled:cursor-not-allowed disabled:opacity-35 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#35dceb]" aria-label={`Add one more ${label} to cart`} data-id="element-258" data-mp="1d7x3tyf54wwg">
          <PlusIcon size={16} aria-hidden="true" data-id="element-259" data-mp="1u1q8u3vww7c" />
        </button>
        <button type="button" onClick={openCart} className="whitespace-nowrap text-sm font-medium text-[#35dceb] underline decoration-transparent underline-offset-4 transition-colors duration-150 ease-out hover:decoration-current focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#35dceb]" data-id="element-260" data-mp="1s8kri50ci0x">
          In cart · View
        </button>
      </div>
      {hasReachedInventory && <p className="mt-2 text-xs text-white/60" data-id="element-261" data-mp="24fxdbvl7t48r">Maximum available quantity in your cart.</p>}
    </div>;
}